import Colocaciones from './ColocacionDashboardList'

export default Colocaciones
